<template>
  <div class="sala">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div :class="cita.citas.length > 1 ? 'cita1' : 'cita'"
         v-if="cita !== undefined && mostrarPorEspecialidadFiltro(cita)"
         :style="cita.style"
         v-b-tooltip.hover.left
         :title="cita.titleDebug"
         @click="mostrarDetalle">

      <div class="v-line">
      </div>

      <div v-if="dia" dir="auto" :class="{'doc':true, 'cita-urgencia':cita.citaUrgencia}"
           :style="'top:'+(cita.tamanioN/3)+'px; '" >
        <b style="font-size: 10px; ">
          {{cita.notacionCanalOrigen}}
          {{cita.inicialesDoctor}}
        </b>
        <template v-if="this.filtros.options.planes !== undefined && this.filtros.options.planes !== null" class="imgLogo">
          <template v-for="ct in cita.citas" >
             <span v-for="planImg in ct.idsPlanes" :key="planImg">
              <img alt="sala Calendario" style=" width: 50%;" :src="'data:image/png;base64, '+ obtenerImagen(planImg)" v-if="obtenerImagen(planImg)"/>
             </span>
          </template>
        </template>
        <span dir="auto" class="aseguradora"
              v-if="cita.mostrarSiglasAseguradora">
        -{{cita.siglasAseguradora}}</span>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  name: "SalaCalendarioNuevoDia",
  components: {},
  props: {
    numeroSala: {
      type: Number,
      default: -1
    },
    cita: {
      type: Object
    },
    dia: Boolean,
    filtros: Object
  },
  computed: {
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    citaUrgencia: false
  }),
  beforeCreate: function () {
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    obtenerImagen(idPlan) {
      const planImg = this.filtros.options.planes.find(it=>it.id===idPlan);

      if (planImg !== undefined && planImg !== null) {
        return planImg.img;
      }
      return null;
    },
    mostrarPorEspecialidadFiltro(cita) {

      let mostrarConfianza = false;
      let mostrarMontoPti = false;
      let mostrarMotC = false;
      let mostrarCC = false;
      let mostrarEstC = false;
      let mostrarEsp = false;
      let mostrarPlanes = false;
      let mostrarPacienteNatural = false;
      let mostrarTipoPaciente = false;
      let mostrarDoctor = false;
      let mostrarSillon = false;

      cita.citas.forEach(c => {

        const esp = c.idEspecialidadDoctor.split(",").map(Number);
        try {
          if (esp instanceof Array) {
            esp.forEach(es0 => {
              if(this.filtros.selects.especialidades.map(Number).includes(es0)) {
                mostrarEsp = true;
              }
            });
          }
        } catch(e) {
          console.error(e);
          return false;
        }

        if(this.filtros.selects.porcentajeConfianza[0] <= c.probabilidadMinima && this.filtros.selects.porcentajeConfianza[1] >= c.probabilidadMaxima) {
          mostrarConfianza = true;
        }

        if(this.filtros.selects.montoPti[0] == 0 || (this.filtros.selects.montoPti[0] <= c.montoPti && this.filtros.selects.montoPti[1] >= c.montoPti)) {
          mostrarMontoPti = true;
        }

        if (this.filtros.selects.motivosCita.includes(c.motivoCitaTag)) {
          mostrarMotC = true;
        }
        if (this.filtros.selects.canalCita.includes(c.idCanalOrigen)) {
          mostrarCC = true;
        }
        if (this.filtros.selects.estatusCita.map(Number).includes(Number(c.idEstatusCita))) {
          mostrarEstC = true;
        }

        if (this.filtros.selects.pacienteNatural) {
          mostrarPacienteNatural = (c.idsPlanes === undefined || c.idsPlanes === null || c.idsPlanes.length <= 0);
        } else {
          mostrarPacienteNatural =
              (!this.filtros.selects.pacienteNatural && !this.filtros.selects.pacientePlan) ||
              this.filtros.selects.pacienteNatural;
        }

        if (c.idsPlanes !== undefined && c.idsPlanes !== null) {

          mostrarPlanes = (!this.filtros.selects.pacienteNatural && this.filtros.selects.pacientePlan) ||
              (this.filtros.selects.pacientePlan);

          if (this.filtros.selects.planes.length > 0) {
            mostrarPlanes = false;
            c.idsPlanes.forEach(pp => {
              if (this.filtros.selects.planes.map(Number).includes(pp)) {
                mostrarPlanes = true;
              }
            });
          }

        }

        const subtipoP = Number(c.idSubTipoPaciente) === 4 ? 1 : Number(c.idSubTipoPaciente);
        if (this.filtros.selects.tipos.map(Number).includes(subtipoP)) {
          mostrarTipoPaciente = true;
        }

        if (this.filtros.selects.doctores.map(Number).includes(Number(c.idDoctor))) {
          mostrarDoctor = true;
        }

        if (this.filtros.selects.sillones.map(Number).includes(Number(c.sillon))) {
          mostrarSillon = true;
        }

      });

      return (mostrarConfianza)
          && mostrarMontoPti
          && (this.filtros.selects.especialidades.length === 0 || mostrarEsp)
          && (this.filtros.selects.motivosCita.length === 0 || mostrarMotC)
          && (this.filtros.selects.canalCita.length === 0 || mostrarCC)
          && (this.filtros.selects.estatusCita.length === 0 || mostrarEstC)
          && (mostrarPlanes || mostrarPacienteNatural)
          && (this.filtros.selects.tipos.length === 0 || mostrarTipoPaciente)
          && (this.filtros.selects.doctores.length === 0 || mostrarDoctor)
          && (this.filtros.selects.sillones.length === 0 || mostrarSillon);

    },
    mostrarDetalle() {
      this.$emit("mostrarDetalle", this.cita);
    }
  }
};
</script>

<style scoped>
@import '~vue-context/dist/css/vue-context.css';

.sala {
  /*min-width: 35px;*/
  text-align: center;
  width: 0px !important;
  height: 20px;
  font-size: small;
  font-weight: bolder;
}

.fa {
  font-size: 13px !important;
  margin-top: 10px !important;
}

.md-icon-button {
  width: 14px !important;
  min-width: 14px !important;;
  height: 14px !important;;
  margin: 0px !important;;
  font-size: 11px !important;;
}

.cita {
  position: absolute;
  margin-top: -4px;
  display: block;
  width: 20px;
  font-size: 0.4em;
  margin-left: 2px;
  z-index: 6;
  border-radius: 7px;
  border: solid 1px black;
  font-weight: bold;
  color: white;
}

.cita1 {
  position: absolute;
  background: repeating-linear-gradient(
      45deg,
      rgba(0, 0, 0, 0) 50px,
      rgba(0, 0, 0, 0) 1px,
      #E7AD23 1px,
      #FEF89F 60px
  );
  margin-top: -4px;
  margin-left: 0px;
  display: block;
  width: 20px;
  font-size: 0.4em;
  z-index: 8;
  border-radius: 9px;
  border: solid 2px white;
  font-weight: bold;
  color: white;
}

.cita-urgencia{
  color:red !important;
}

.copete {
  position: absolute;
  width: 29px;
  border-top-left-radius: 6px;
  border-top-right-radius: 6px;
  left: 0px;
  top: 0px;
}

.body-sala {
  position: absolute;
  width: 18px;
  left: 0px;
  top: 7px;
}

.aseguradora {
  position: absolute;
  left: 1px;
  top: 6px;
  font-size: 2em;
  color: white;
  background-color: black;
  border: 1px solid black;
  border-radius: 3px;
}

.doc {
  position: relative;
  left: 1px;
  top: 8px;
  font-size: 2em;
  color: white;
  /*background-color: black;
  border: 1px solid black;
  border-radius: 3px;*/
}
.v-line{
  border-left: thick solid #ffffff;
  height:100%;
  left: 0%;
  position: absolute;
  border-radius: 40px 10px 10px 40px;
}
.label {
  display: inline-block;
   margin-bottom: 0.1rem;
}
</style>
